import { render, staticRenderFns } from "./indomaret.vue?vue&type=template&id=f8b97a82&scoped=true"
import script from "./indomaret.vue?vue&type=script&lang=js"
export * from "./indomaret.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b97a82",
  null
  
)

export default component.exports